import { SecurityMasterPatcher } from './security-master-patcher.cls';
/**
 *
 */
export const NSPatchers = {
    SecurityMasterPatcher
};



//////////////////
// WEBPACK FOOTER
// ./src/plugins/vue-provider-cache/provider/ws-price-feed/patcher/index.ts
// module id = null
// module chunks = 